<template >
  <b-container fluid>
    <b-row>
      <b-col cols="12" md="4" lg="2">
        <b-form-group label="Estado:">
          <b-form-radio-group style="border:solid gray 1px; padding:2px; border-radius:5px;" v-model="formasFormModel.inRadioButton.model" :options="formasFormModel.inRadioButton.options" @change="cleanResults"/>
        </b-form-group>
      </b-col>
      <b-col cols="12" md="4" lg="2">
        <b-form-group label="Fecha Inicial:">
          <b-form-input size="sm" :state="!$v.formasFormModel.inDate1.$invalid" type="date" v-model="$v.formasFormModel.inDate1.model.$model" @change="cleanResults" />
          <div class="error" v-if="!$v.formasFormModel.inDate1.model.minValue">La fecha esta fuera del rango.</div>
          <div class="error" v-if="!$v.formasFormModel.inDate1.model.maxValue">La fecha esta fuera del rango.</div>
          <div class="error" v-if="!$v.formasFormModel.inDate1.model.sameMonth">Las fechas deben ser del mismo mes.</div>
        </b-form-group>
      </b-col>
      <b-col cols="12" md="4" lg="2">
        <b-form-group label="Fecha Final:">
          <b-form-input size="sm" :state="!$v.formasFormModel.inDate2.$invalid" type="date" v-model="$v.formasFormModel.inDate2.model.$model" @change="cleanResults" />
          <div class="error" v-if="!$v.formasFormModel.inDate2.model.minValue">La fecha esta fuera del rango.</div>
          <div class="error" v-if="!$v.formasFormModel.inDate2.model.maxValue">La fecha esta fuera del rango.</div>
          <div class="error" v-if="!$v.formasFormModel.inDate2.model.sameMonth">Las fechas deben ser del mismo mes.</div>
        </b-form-group>
      </b-col>
      <b-col cols="12" md="4" lg="2">
        <b-form-group label="Usuario:">
          <b-form-select size="sm" v-if="formasFormModel.inSelectTipoForma.model == 'ÓRDENES DE PAGO'" :state="!$v.formasFormModel.inSelectUser.$invalid" v-model="$v.formasFormModel.inSelectUser.model.$model" :options="catalogFormas.usuariosOrdenes" @change="cleanResults" />
          <b-form-select size="sm" v-if="formasFormModel.inSelectTipoForma.model == 'RECIBOS DEL SISTEMA'" :state="!$v.formasFormModel.inSelectUser.$invalid" v-model="$v.formasFormModel.inSelectUser.model.$model" :options="catalogFormas.usuariosRecibos" @change="cleanResults" />
          <div class="error" v-if="!$v.formasFormModel.inSelectUser.model.required">Este campo es obligatorio.</div>
        </b-form-group>
      </b-col>
      <b-col cols="12" md="4" lg="4">
        <b-form-group label="Concepto:">
          <b-form-select size="sm" :state="!$v.formasFormModel.inSelectConcepto.$invalid" v-model="$v.formasFormModel.inSelectConcepto.model.$model" :options="catalogFormas.conceptosBusqueda" @change="cleanResults" />
          <div class="error" v-if="!$v.formasFormModel.inSelectConcepto.model.required">Este campo es obligatorio.</div>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
			<!-- <b-col cols="12" md="3">
        <b-form-group label="Nombre del contribuyente:">
          <b-form-input size="sm" :state="!$v.formasFormModel.inTxtNombre.$invalid" type="text" v-model.trim="$v.formasFormModel.inTxtNombre.model.$model" @change="cleanResults" />
          <div class="error" v-if="!$v.formasFormModel.inTxtNombre.model.minLength">Debe ingresar 20 caracteres.</div>
          <div class="error" v-if="!$v.formasFormModel.inTxtNombre.model.maxLength">Debe ingresar 20 caracteres.</div>
          <div class="error" v-if="!$v.formasFormModel.inTxtNombre.model.alpha">Este campo solo admite caracteres a-z y A-Z</div>
        </b-form-group>
      </b-col>
      <b-col cols="12" md="3">
        <b-form-group label="Total entre:">
          <b-form-input size="sm" :state="!$v.formasFormModel.inNum1.$invalid" type="number" v-model.trim="$v.formasFormModel.inNum1.model.$model" @change="cleanResults" />
          <div class="error" v-if="!$v.formasFormModel.inNum1.model.between">Debe ingresar una cantidad entre 0 y 999999999.</div>
        </b-form-group>
      </b-col>
      <b-col cols="12" md="3">
        <b-form-group label="y:">
          <b-form-input size="sm" :state="!$v.formasFormModel.inNum2.$invalid" type="number" v-model.trim="$v.formasFormModel.inNum2.model.$model" @change="cleanResults" />
          <div class="error" v-if="!$v.formasFormModel.inNum2.model.between">Debe ingresar una cantidad entre 0 y 999999999.</div>
        </b-form-group>
      </b-col> -->
      
      
    </b-row>
    <b-row>
      <b-col cols="12" md="8" lg="2" class="mb-4 mt-2">
        <b-button block @click="getFormasValoradas" variant="success" size="sm">
          <b-spinner v-if="isConsultando"></b-spinner>
          <b-icon icon="search" v-if="!isConsultando"/>
          <strong v-if="isConsultando">&nbsp;&nbsp; Buscando . . .</strong>
          <strong v-if="!isConsultando">Buscar </strong>
        </b-button>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
  import axios from 'axios'
  import { minLength, maxLength, between, helpers, requiredIf } from 'vuelidate/lib/validators'
  import { mapState} from 'vuex'
  import { server, checkAuth, getPostConfig, handledError} from '@/axios-tools'

  const alpha = helpers.regex('alpha', /^[a-zA-Z ]*$/)

  export default {
    data(){
      return {
        
      }
    },
    computed: mapState ({
      isConsultando: state => state.formas.isConsultando,
      formasFormModel: state => state.formas.formasFormModel,
      catalogFormas: state => state.formas.catalogFormas,
      token: state => state.login.token
    }),
    methods: {
      cleanResults (){
        this.$store.commit("updateFormas", []);
        this.$store.commit("updateFormasClasificado", null);
        this.$store.commit("updateMsgErrorFormasSimple", "");
        this.$store.commit("updateMsgFormasCancelar", '');
        this.$store.commit("updateTotalRecibosMonto", null);
      },
      getFormasValoradas: function () {            
        if(!this.isConsultando & !this.$v.$invalid & checkAuth(this.$router, this.$store)){
          this.$store.commit("updateIsConsultando", true);
          this.cleanResults();
        if(this.formasFormModel.inSelectTipoForma.model == "RECIBOS DEL SISTEMA"){
          axios(
            getPostConfig(server.recibos, this.formasFormModel, this.token)
            ).then(res => {
              this.$store.commit("updateFormas", res.data[0]);
              this.$store.commit("updateIsFormCollapse", true);
              //this.$store.commit("updateTotalRecibosMonto", res.data[1]);
              this.$store.commit("updateIsConsultando", false);
              if(res.data[1]!=null){
                this.$store.commit("updateFormasClasificado", res.data[1]);
              }
          }).catch(err => {
              this.$store.commit("updateIsConsultando", false);
              handledError(err, server.ordenes, this.$router, this.$store);
          })
        }
        if(this.formasFormModel.inSelectTipoForma.model == "ÓRDENES DE PAGO"){
          axios(
            getPostConfig(server.ordenes, this.formasFormModel, this.token)
            ).then(res => {
              this.$store.commit("updateFormas", res.data);
              this.$store.commit("updateIsFormCollapse", true);
              this.$store.commit("updateIsConsultando", false);
          }).catch(err => {
              this.$store.commit("updateIsConsultando", false);
              handledError(err, server.ordenes, this.$router, this.$store);
          })
        }
        }
      }
    },
    validations: {
      formasFormModel: {
        inTxtNombre: {
          model: {
            alpha,
            minLength: minLength(1),
            maxLength: maxLength(200)
          }
        },
        inNum1: {
          model: {
            between: between(0, 999999999)
          }
        },
        inNum2: {
          model: {
            between: between(0, 999999999)
          }
        },
        inDate1:{
          model:{
              minValue: value => value > new Date(1999,0,1).toISOString(),
              maxValue: value => value < new Date(new Date().getFullYear(),11,31).toISOString(),
              sameMonth: function(){return this.formasFormModel.inDate2.model.substring(0,7) == 
                                              this.formasFormModel.inDate1.model.substring(0,7)}
          }
        },
        inDate2:{
          model:{
              minValue: value => value > new Date(1999,0,1).toISOString(),
              maxValue: value => value < new Date(new Date().getFullYear(),11,31).toISOString(),
              sameMonth: function(){return this.formasFormModel.inDate2.model.substring(0,7) == 
                                              this.formasFormModel.inDate1.model.substring(0,7)}
          }
        },
        inSelectUser:{
          model:{
            required: requiredIf(function(){return this.formasFormModel.inSelectTipoBusqueda.model=='BÚSQUEDA AVANZADA'})
          }
        },
        inSelectConcepto:{
          model:{
            required: requiredIf(function(){return this.formasFormModel.inSelectTipoBusqueda.model=='BÚSQUEDA AVANZADA'})
          }
        }
      }
    }
  }
</script>
<style>
div.error {color: red; font-size: 80%;}
</style>